import React, { useEffect, useState, useRef } from 'react';
import _ from 'lodash';
import { RPCFactory } from '../../../utils/RequestUtil';
import { beaconInstance } from '../../../instrumentation/beaconSetup';
import { PieChart } from './pieChart';
import { BarChart } from './barChart';
import { multipleColor } from './index';

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}
export const DistributeChart = React.memo((props) => {
  const [distribteData, setDistributeData] = useState({ overallData: {}, trendData: {} });
  const previousParams = usePrevious(props.queryParams);
  const [target, setTarget] = useState('USER');
  useEffect(() => {
    if (props.queryParams.startCreateTime && !_.isEqual(props.queryParams, previousParams)) {
      if (props.queryParams.ownerIds) {
        setTarget('USER');
      }
      RPCFactory.leadsReport
        .getLeadsDistribute(props.queryParams)
        .done((data) => {
          setDistributeData(data);
          props.setLeadsData(data.trendData);
        })
        .fail((ret, msg) => {
          alert(msg);
        });
    }
  }, [props.queryParams]);

  const [employeeNameList, setEmployeeNameList] = useState([]);
  const [employeeValueList, setEmployeeValueList] = useState([]);
  useEffect(() => {
    let index = 1;
    if (target === 'USER') {
      index = 0;
    }
    if (distribteData.detailDataList && distribteData.detailDataList[index].entities) {
      setEmployeeNameList(
        distribteData.detailDataList[index].entities.map((item) => ({
          value: item.label,
          textStyle: { fontSize: 10 },
        })),
      );
      setEmployeeValueList(distribteData.detailDataList[index].entities.map((item) => item.value));
    }
  }, [target, distribteData]);
  const switchTargetTo = (target) => {
    setTarget(target);
    beaconInstance.onUserAction('employChart_switch_distribute_target', {
      accountId: window.pageProps.uid,
      companyName: window.pageProps.companyName,
      target,
    });
  };
  return (
    <div className="distribute-analysis display-flex">
      <PieChart
        overallData={distribteData.overallData}
        total={distribteData.trendData.total}
        pieColor={['#FFAC40', '#4080FF']}
        title="分配状态分布（单位：条）"
      />
      <div className="space-divider" />
      <BarChart
        xAxisData={employeeNameList}
        yAxisData={[{ name: '分配线索数', data: employeeValueList, color: multipleColor[0] }]}
        title="线索分配情况"
        target={target}
        setTarget={switchTargetTo}
        hideSwitcher={!!props.queryParams.ownerIds}
      />
    </div>
  );
});
